import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
interface Props {
  label: string;
  icon: ReactElement;
}
function CheckText({ label, icon }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box style={{ marginLeft: '8px', marginTop: '8px' }}>{icon}</Box>
      <Typography> {label}</Typography>
    </Box>
  );
}

export default CheckText;
